import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';
import { useRouter, type RouterContext, type RouterDataContext } from '@atlassian/jira-router';

export const APPS_SECTION_ROUTES = new Set<string>([
	// Connect apps
	ROUTE_NAMES.CONNECT_GENERAL,
	ROUTE_NAMES.CONNECT_GENERAL_INVALID, // It seems like some apps may generate invalid urls, but we still have to handle them
	ROUTE_NAMES.CONNECT_GENERAL_SERVICE_DESK_PROJECT,
	ROUTE_NAMES.LEGACY_CONNECT_GENERAL,
	// Forge apps
	ROUTE_NAMES.FORGE_GLOBAL,
	// Marketplace routes
	ROUTE_NAMES.MARKETPLACE_INDEX,
]);

export function useIsAppsSectionRoute() {
	const [routerContext] = useRouter();
	return isAppsSectionRoute(routerContext);
}

export function isAppsSectionRoute(routerContext: RouterContext | RouterDataContext) {
	const { route } = routerContext;
	return APPS_SECTION_ROUTES.has(route.name);
}
